// 交易所公告列表
export const GETNOTICELIST = 'get-notice-list'
// 交易所信息列表
export const GETBOURSELIST = 'get-bourse-list'
// 交易所公告统计列表
export const GETBOURSESTATISTICSLIST = 'get-bourse-statistics-list'
// 交易所公告详情
export const GETNOTICEDETAIL = 'get-notice-detail'
